import React from 'react';
import Reflux from 'reflux';
import api from "../../source/api";

export default class DownloadFile extends Reflux.Component {
    handleClick = (event) => {
        event.preventDefault();

        api.downloadFile(
            this.props.url,
            this.props.name,
        );
    };

    render() {
        return (
            <a
                href={this.props.url}
                className={this.props.className || 'green-btn uppercase mr-2'}
                onClick={this.handleClick}
            >
                {this.props.title}
            </a>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/common/DownloadFile.js